import {
  Action,
  ActionFromReducersMapObject,
  combineReducers,
  configureStore,
  ReducersMapObject,
  StateFromReducersMapObject,
} from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import localStorage from 'redux-persist/es/storage'
import { academicSession } from '../slices/academicSessionSlice'
import downloadReportSlice from '../slices/downloadReportSlice'
import { facultySlice } from '../slices/facultySlice'
import reportSlice from '../slices/reportSlice'
import authReduce from '@school/common/common-utils/slices/authSlice'
import dropReduce from '@school/common/common-utils/slices/dropDownSlice'

import dummySlice from '@school/console-utils/common-utils/slices/dummySlice'
import userRoleSlice from '@school/common/common-utils/slices/userRoleSlice'
import userReduce from '@school/common/common-utils/slices/userSlice'
import chartReduce from '@school/common/common-utils/slices/chartSlice'

// Define the reducers map
const bpmsReducer: ReducersMapObject<any, Action<any>> = {
  [dummySlice.name]: dummySlice.reducer,
  [reportSlice.name]: reportSlice.reducer,
  [downloadReportSlice.name]: downloadReportSlice.reducer,
  [facultySlice.name]: facultySlice.reducer,
  [academicSession.name]: academicSession.reducer,
}

// Persist configuration
const persistConfig = {
  key: 'root',
  storage: localStorage,
  //whitelist: ['faculty', 'academicSessionFromParent', 'academicSession'],
  whitelist: ['userSlice'], // ✅ only static reducers here
}

const rootReducer = combineReducers({
  faculty: facultySlice.reducer,
  academicSession: academicSession.reducer,
  report: reportSlice.reducer,
  downloadReport: downloadReportSlice.reducer,
  dummy: dummySlice.reducer,
  userSlice: userRoleSlice.reducer, //get for role data
  auth: authReduce, //get for auth user data
  user: userReduce, //get users info
  chart: chartReduce, //get chart data
  drop: dropReduce,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>

export type CMSRootState = RootState & StateFromReducersMapObject<typeof bpmsReducer>
export type AppDispatch = typeof store.dispatch & ActionFromReducersMapObject<typeof bpmsReducer>
